import { ApexOptions } from 'apexcharts';
import ReactApexChart from 'react-apexcharts';
import { getDateUsingFormat } from 'wisestep-base';

import { ISeriesDataType } from '../../../../analytics/types';
import { IClientsAnalyticsChartsProps, processPeriod } from '../helper/payloadsAndTypesHelper';
import useGetSalesTrendOrderBookWise from '../Hooks/useGetSalesTrendOrderBookWise';

const SalesTrendOrderBookBarChart = ({
  clientsAnalyticsChartsProps,
}: IClientsAnalyticsChartsProps) => {
  const title = `Sales Trend OrderBookWise for ${processPeriod(
    clientsAnalyticsChartsProps.period
  )}`;
  const data = useGetSalesTrendOrderBookWise(clientsAnalyticsChartsProps);

  const bucketData: ISeriesDataType[] = [];

  data?.forEach((item) => {
    bucketData.push({
      y: Number(item.sales?.toFixed(2)),
      x: getDateUsingFormat(new Date(item.joiningDateToPeriod)?.toString(), 'DD-MMM-YY'),
    });
  });

  const options: ApexOptions = {
    chart: {
      height: 450,
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      type: 'datetime',
      title: {
        text: title,
      },
    },
    yaxis: {
      title: {
        text: 'Count',
      },
    },
    dataLabels: {
      enabled: false,
    },
    title: {
      text: title,
    },
  };
  const series = [
    {
      data: bucketData,
      name: title,
    },
  ];
  return <ReactApexChart options={options} series={series} type="bar" height="100%" width="100%" />;
};

export default SalesTrendOrderBookBarChart;
